// Minimal, dependency-free carousel controller shared by every instance of
// the premium featured-collection section (Meilleures Ventes, Nouveautés,
// and any future instance of the same component). Handles arrow buttons,
// keyboard navigation, and optional autoplay. Native CSS scroll-snap +
// touch scrolling handle swipe. Card markup, cart logic, and quick-add are
// untouched (see featured-collection-premium.js and
// card-product-premium.liquid) — this file only moves the track.
(function () {
  if (window.__fcpCarouselInit) return;
  window.__fcpCarouselInit = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initCarousel(track) {
    var wrap = track.closest('.fcp-carousel-wrap');
    if (!wrap) return;

    var prevBtn = wrap.querySelector('[data-fcp-carousel-prev]');
    var nextBtn = wrap.querySelector('[data-fcp-carousel-next]');
    var speed = parseInt(track.dataset.scrollSpeed, 10) || 500;
    var autoplay = track.dataset.autoplay === 'true' && !reduceMotion;
    var autoplayInterval = parseInt(track.dataset.autoplayInterval, 10) || 5000;
    var rafId = null;
    var autoplayTimer = null;

    function stepDistance() {
      var item = track.querySelector('.fcp-grid__item');
      if (!item) return track.clientWidth * 0.9;
      var trackStyle = window.getComputedStyle(track);
      var gap = parseFloat(trackStyle.columnGap || trackStyle.gap || '0') || 0;
      return item.getBoundingClientRect().width + gap;
    }

    function maxScroll() {
      return track.scrollWidth - track.clientWidth;
    }

    function scrollByAmount(delta) {
      var start = track.scrollLeft;
      var target = Math.max(0, Math.min(start + delta, maxScroll()));

      if (reduceMotion) {
        track.scrollLeft = target;
        return;
      }

      if (rafId) cancelAnimationFrame(rafId);
      var startTime = null;

      function animate(timestamp) {
        if (startTime === null) startTime = timestamp;
        var progress = Math.min((timestamp - startTime) / speed, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        track.scrollLeft = start + (target - start) * eased;
        if (progress < 1) {
          rafId = requestAnimationFrame(animate);
        } else {
          rafId = null;
        }
      }

      rafId = requestAnimationFrame(animate);
    }

    function updateArrowState() {
      var max = maxScroll() - 1;
      if (prevBtn) prevBtn.disabled = track.scrollLeft <= 0;
      if (nextBtn) nextBtn.disabled = max <= 0 || track.scrollLeft >= max;
    }

    function advance() {
      if (track.scrollLeft >= maxScroll() - 1) {
        // Loop back to the start for a continuous autoplay feel.
        scrollByAmount(-track.scrollLeft);
      } else {
        scrollByAmount(stepDistance());
      }
    }

    function startAutoplay() {
      if (!autoplay || autoplayTimer || maxScroll() <= 0) return;
      autoplayTimer = window.setInterval(advance, autoplayInterval);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        stopAutoplay();
        scrollByAmount(-stepDistance());
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        stopAutoplay();
        scrollByAmount(stepDistance());
      });
    }

    track.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        stopAutoplay();
        scrollByAmount(stepDistance());
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        stopAutoplay();
        scrollByAmount(-stepDistance());
      }
    });

    var scrollTimeout;
    track.addEventListener(
      'scroll',
      function () {
        window.clearTimeout(scrollTimeout);
        scrollTimeout = window.setTimeout(updateArrowState, 60);
      },
      { passive: true }
    );

    if (autoplay) {
      wrap.addEventListener('mouseenter', stopAutoplay);
      wrap.addEventListener('mouseleave', startAutoplay);
      wrap.addEventListener('focusin', stopAutoplay);
      wrap.addEventListener('focusout', startAutoplay);
      wrap.addEventListener('touchstart', stopAutoplay, { passive: true });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          stopAutoplay();
        } else {
          startAutoplay();
        }
      });
      startAutoplay();
    }

    window.addEventListener('resize', updateArrowState, { passive: true });
    updateArrowState();
  }

  function init() {
    document.querySelectorAll('[data-fcp-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
